import {
	Table, Popconfirm, Pagination, Select
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	useDebounce
}from 'use-debounce'
import Notifications from '../../../helpers/Notifications'
import {
	rePossibleCharacteristicActions
}from './store/actions'
import './style.css'
import moment from "moment"
import CustomButton from '../../../components/CustomButton'
import CustomInput from '../../../components/CustomInput'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import UpdateIcon from '../../../components/Icons/update.svg'
import AddIcon from '../../../components/Icons/add.svg'
import AuditIcon from '../../../components/Icons/audit.svg'
import RePossibleCharacteristicChangeForm from "./change"
import LocalLoading from '../../../components/Loading/Local'
import CustomSelect from '../../../components/CustomSelect'
import {
	reCharacteristicActions
}from '../ReCharacteristic/store/actions'
import ModalAudit from '../ModalAudit'

const RePossibleCharacteristic = ({ isModify = false }) => {
	const pageSize = 10
	const [visible, setVisible] = useState(false)
	const [auditVisible, setAuditVisible] = useState(false)
	const [record, setRecord] = useState(null)
	const [audit, setAudit] = useState(null)
	const [page, setPage] = useState(1)
	const [search, setSearch] = useState(null)
	const [searchChar, setSearchChar] = useState(null)
	const [characteristic, setCharacteristic] = useState(null)

	const { isSending, changed, paged, pagedAudit } = useSelector((state) => state.rePossibleCharacteristicReducer)
	const characteristics = useSelector(state => state.reCharacteristicReducer.list)

	const [searchValue] = useDebounce(search, 500)
	const [characteristicValue] = useDebounce(searchChar, 500)
	const dispatch = useDispatch()

	const columns = [
		{
			dataIndex : 'value',
			inputType : 'text',
			key       : 'value',
			title     : 'Значение',
			width     : "80%"
		},
		{
			title     : "Дата создания",
			dataIndex : 'createDate',
			key       : 'createDate',
			width     : !isModify ? "20%" : "12%",
			render    : (date) => moment(date).format("DD.MM.YYYY")
		}
	]

	const columnsAudit = [
		{
			dataIndex : "action",
			key       : "action",
			title     : "Действие"
		},
		{
			dataIndex : 'value',
			inputType : 'text',
			key       : 'value',
			title     : 'Значение',
			width     : "80%"
		},
		{
			key       : "actionDateTime",
			title     : "Дата изменения",
			dataIndex : "actionDateTime"
		},
		{
			title     : "IP-адрес",
			key       : "ip",
			dataIndex : "ip"
		}
	]

	const getPaged = params => {
		dispatch(rePossibleCharacteristicActions.getPaged(params))
	}
	const getPagedAll = params => {
		dispatch(rePossibleCharacteristicActions.getPagedAll(params))
	}
	const getPagedAudit = (params) => {
		dispatch(rePossibleCharacteristicActions.getPagedAudit(params))
	}
	const create = params => {
		dispatch(rePossibleCharacteristicActions.create(params))
	}
	const remove = params => {
		dispatch(rePossibleCharacteristicActions.remove(params))
	}
	const update = params => {
		dispatch(rePossibleCharacteristicActions.update(params))
	}
	const restore = params => {
		dispatch(rePossibleCharacteristicActions.restore(params))
	}
	const getCharacteristics = (values) => {
		dispatch(reCharacteristicActions.getList(values))
	}

	useEffect(() => {
		return () => {
			dispatch(rePossibleCharacteristicActions.clear())
			dispatch(reCharacteristicActions.clear())
		}
	}, [])

	useEffect(() => {
		if (changed){
			Notifications.successNotice(changed, "", 15)
			onPaginationChange(page)
			setVisible(false)
		}
	}, [changed])

	useEffect(() => {
		getCharacteristics({
			name     : characteristicValue,
			isSelect : true,
			pageSize : pageSize
		})
	}, [characteristicValue])

	useEffect(() => {
		if (characteristic || searchValue != null)
			onPaginationChange(1)
	}, [characteristic, searchValue])

	useEffect(() => {
		onPaginationAuditChange(1)
	}, [audit])

	function onPaginationChange(page){
		setPage(page)
		const params = {
			characteristicId : characteristic,
			value            : searchValue?.trim(),
			pageSize         : pageSize,
			page             : page
		}
		if (isModify)
			getPagedAll(params)
		else
			getPaged(params)
	}

	function onPaginationAuditChange(value){
		if (audit){
			getPagedAudit({
				id   : audit,
				page : value,
				pageSize
			})
		}
	}

	isModify
		? columns.push({
			dataIndex : "id",
			key       : 'id',
			width     : "8%",
			render    : (id, record) => (
				<div className="changeIcon">
					<img
						src={ UpdateIcon }
						title="Редактировать"
						onClick={ () => {
							setVisible(true)
							setRecord(record)
						} }
					/>
					<Popconfirm
						cancelText="Нет"
						okText="Да"
						placement="left"
						title={ !record.isDeleted ? 'Вы уверены, что хотите удалить данную запись?' : 'Вы уверены, что хотите восстановить данную запись?' }
						onCancel={ (e) => {
							e.stopPropagation()
							return null
						} }
						onConfirm={ (e) => {
							e.stopPropagation()
							!record.isDeleted ? remove({ id }) : restore({ id })
						} }
					>
						<img
							src={ !record.isDeleted ? DeleteIcon :RestoreIcon }
							title={ !record.isDeleted ? "Удалить" : "Восстановить" }
						/>
					</Popconfirm>
					<img
						className="audit-icon-svg"
						src={ AuditIcon }
						title="История изменений"
						onClick={ () => {
							setAuditVisible(true)
							setAudit(record.id)
						} }
					/>
				</div>
			)
		})
		: null

	return (
		<>
			<div className="header-nsi possible-characters">
				<CustomSelect
					allowClear
					showSearch
					filterOption={ false }
					notFoundContent={ null }
					placeholder="Выберите характеристику"
					onChange={ (value) => {
						setCharacteristic(value)
					} }
					onSearch={ value => setSearchChar(value) }
				>
					{ characteristics?.map(item => {
						return (
							<Select.Option
								key={ item.id }
								title={ `(${ item.code }) ${ item.name }` }
								value={ item.id }
							>
								{ `(${ item.code }) ${ item.name }` }
							</Select.Option>)
					}) }
				</CustomSelect>
			</div>
			{ characteristic
				? (
					<>
						<div className="header-admin-nsi">
							<CustomInput
								maxLength={ 64 }
								placeholder="Введите значение"
								onChange={ (e) => setSearch(e.target.value) }
							/>
							{ isModify
								? (
									<CustomButton
										className="add-nsi"
										type="green"
										onClick={ () => {
											setRecord(null)
											setVisible(true)
										} }
									>
										<div>
											<img src={ AddIcon } />
											<span>
												Добавить
											</span>
										</div>
									</CustomButton>
								)
								: null }
						</div>
						<Table
							columns={ columns }
							dataSource={ paged?.items }
							loading={ { indicator : <LocalLoading />,
								spinning  : isSending } }
							pagination={ false }
							scroll={ { x: 1100 } }
						/>
						{ paged?.count > pageSize &&
								<Pagination
									showQuickJumper
									current={ page }
									pageSize={ pageSize }
									showSizeChanger={ false }
									size="small"
									total={ paged.count }
									onChange={ onPaginationChange }
								/> }
						{ isModify &&
						<>
							<RePossibleCharacteristicChangeForm
								characteristic={ characteristic }
								create={ create }
								record={ record }
								setRecord={ setRecord }
								setVisible={ setVisible }
								update={ update }
								visible={ visible }
							/>
							<ModalAudit
								columns={ columnsAudit }
								count={ pagedAudit.count }
								data={ pagedAudit.items }
								setIdRecordAudit={ setAudit }
								setPage={ onPaginationAuditChange }
								setVisible={ setAuditVisible }
								visible={ auditVisible }
							/>
						</> }
					</>
				)
				: null }

		</>
	)
}

export default RePossibleCharacteristic
